import React, { useState, useEffect, useCallback } from 'react';
import {
  GetScheduledInterviews,
  getAllCompanies,
  getStudents,
} from '../../../services/apiService';
import InterviewsTable from './_utils/table';
import { Dropdown } from 'semantic-ui-react';
import { getFullName } from '../../../utils';
import useFilterPlacementSpoc from '../_utils/useFilterPlacementSpoc';
import usePaginationState from '../_utils/usePaginationState';
import CustomPagination from '../_components/CustomPagination';

function InterviewSchedule() {
  const [data, setData] = useState([]);
  const [students, setStudents] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [studentIds, setStudentIds] = useState([]);
  const [sortType, setSortType] = useState('DESC');
  const ERoundStatus = {
    UNSCHEDULED: 'unscheduled',
    SCHEDULED: 'scheduled',
    DECISION_AWAITING: 'decision awaiting',
    CLEARED: 'cleared',
    NOT_CLEARED: 'not cleared',
    PAUSED: 'paused',
  };
  const [status, setStatus] = useState(ERoundStatus.SCHEDULED);

  // const [companyDetails, setCompanyDetails] = useState({
  //   companyId: '',
  //   companyName: '',
  //   companyAvatar: '',
  // });
  const [companies, setCompanies] = useState([]);
  const [companyIds, setCompanyIds] = useState([]);
  const { page, setPage, size, setSize, totalCount, setTotalCount } =
    usePaginationState();
  const {
    loading,
    placementSpocOptions,
    placementSpocFilter,
    setPlacementSpocFilter,
  } = useFilterPlacementSpoc();

  const fetchScheduledRounds = useCallback(async () => {
    try {
      // setLoading(true);
      const response = await GetScheduledInterviews({
        page,
        size,
        placementSpocIds: placementSpocFilter,
        studentIds,
        companyIds,
        sortParams: {
          sortColumn: 'startTime',
          sortType,
        },
        roundStatus: status,
      });
      // setLoading(false);
      setData(response.data);
      setTotalCount(response.totalCount);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  }, [
    page,
    size,
    placementSpocFilter,
    studentIds,
    companyIds,
    sortType,
    status,
  ]);

  // fetch companies
  const fetchStudentOptions = async () => {
    try {
      // setLoading(true);
      const _students = await getStudents();
      // setLoading(false);
      setStudents(_students?.data ?? []);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  // fetch companies
  const fetchCompanyOptions = async () => {
    try {
      // setLoading(true);
      const _companies = await getAllCompanies();
      // setLoading(false);
      setCompanies(_companies?.data ?? []);
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  };

  // fetch all scheduled interview rounds on page load
  useEffect(() => {
    fetchCompanyOptions();
    fetchStudentOptions();
  }, []);
  useEffect(() => {
    if (!loading) fetchScheduledRounds();
  }, [fetchScheduledRounds, loading]);

  // filter the data by the filter value everytime the filter value or job groups data changes
  useEffect(() => {
    // if (data.length > 0) {
    //   let _filteredData = data;
    //   // if (student.studentIds.length > 0) {
    //   //   _filteredData = _filteredData.filter((item) =>
    //   //     student.studentIds.includes(item.studentId)
    //   //   );
    //   // }
    //   // if (companyDetails.companyId) {
    //   //   _filteredData = _filteredData.filter(
    //   //     (item) => item?.companyDetails?.companyId === companyDetails.companyId
    //   //   );
    //   // }
    //   // // filter by Placement Spoc
    //   // if (placementSpocFilter.length > 0) {
    //   //   _filteredData = _filteredData.filter((item) =>
    //   //     placementSpocFilter.includes(item.placementSpocDetails.id)
    //   //   );
    //   // }
    //   setFilteredData(_filteredData);
    // }
    setFilteredData(data);
  }, [data]);

  const renderInterviews = () => {
    return (
      <div>
        <div className='flex items-center justify-between gap-10 my-5 mb-30'>
          <h1 className='text-3xl font-semibold user-heading'>
            Interview Schedule
          </h1>
          <div className='flex gap-2 '>
            {placementSpocOptions.length > 0 && (
              <Dropdown
                placeholder='Placement Spoc'
                options={placementSpocOptions}
                search
                multiple
                selection
                defaultValue={placementSpocFilter}
                onChange={(e, { value }) => {
                  setPage(0);
                  setPlacementSpocFilter(value);
                }}
              />
            )}
            <div className='flex'>
              <Dropdown
                placeholder='Status'
                options={Object.values(ERoundStatus).map((singleStatus) => ({
                  text: `${singleStatus}`,
                  value: `${singleStatus}`,
                }))}
                search
                selection
                onChange={(e, { value }) => {
                  setPage(0);
                  setStatus(value);
                }}
                value={status}
              />
            </div>
            <div className='flex'>
              <Dropdown
                options={students.map((student) => ({
                  key: student?.userId,
                  text: getFullName(student?.userDetails),
                  value: student.userId,
                  image: { avatar: true, src: student?.userDetails?.thumbnail },
                }))}
                onChange={(e, { value, text }) => {
                  setPage(0);
                  setStudentIds(value);
                }}
                placeholder='Students'
                search
                selection
                clearable
                multiple
                value={studentIds}
              />
            </div>
            <div className='flex '>
              <Dropdown
                options={companies.map((company) => ({
                  key: company.companyId,
                  text: company.companyName,
                  value: company.companyId,
                  image: { avatar: true, src: company.companyAvatar },
                }))}
                onChange={(e, { value, text }) => {
                  setPage(0);
                  setCompanyIds(value);
                }}
                placeholder='Search by company'
                search
                selection
                clearable
                multiple
                value={companyIds}
              />
            </div>
          </div>
        </div>
        <div className='mt-15'>
          <InterviewsTable
            rowData={filteredData}
            onReload={() => {
              fetchScheduledRounds();
            }}
            setSortType={setSortType}
          />
        </div>
        <CustomPagination
          page={page}
          setPage={setPage}
          size={size}
          setSize={setSize}
          totalCount={totalCount}
        />
      </div>
    );
  };

  return <div>{renderInterviews()}</div>;
}

export default InterviewSchedule;
